// biographyFormatter.js

export function formatBiography(html) {
    if (!html) return "";

    let updatedHtml = html;

    // Add ql-align-center if text-align center found
    updatedHtml = updatedHtml.replace(
        /<p style="text-align:\s*center;">/g,
        '<p class="ql-align-center">'
    );

    updatedHtml = updatedHtml.replace(
        /<p style="text-align:\s*right;">/g,
        '<p class="ql-align-right">'
    );

    // Example: add ql-size-large for strong inside h1
    updatedHtml = updatedHtml.replace(
        /<h1>/g,
        '<h1 class="ql-size-large">'
    );

    // You can extend rules here as needed

    return updatedHtml;
}